import React from "react";
import classNames from "classnames";

import {ISelectRangeProps} from "../types/ISelectRangeProps";
import {isValueInRange} from "../utils/is_value_in_range";
import {updateSingleValueBounds} from "../utils/update_single_value_bounds";
import {updateValueBounds} from "../utils/update_value_bounds";
import {SelectRangeItem} from "./SelectRangeItem";

import * as styles from "./SelectRange.module.css";

export const SelectRange = (props: ISelectRangeProps) => {
    const {className, itemClassName, name, onChange, options, value, variant = "range"} = props;

    const handleItemChange = (itemName: string, itemValue: number) => {
        if (options.length === 0) return;

        if (variant === "single") {
            onChange(itemName, updateSingleValueBounds(itemValue));
            return;
        }

        const firstOption = options[0];
        const lastOption = options[options.length - 1];
        const allOptionValues = options.map((option) => option.value);

        onChange(itemName, updateValueBounds(value, itemValue, firstOption.value, lastOption.value, allOptionValues));
    };

    if (options.length === 0) {
        return null;
    }

    const firstOption = options[0];
    const lastOption = options[options.length - 1];

    return (
        <ul className={classNames(styles.container, className)}>
            {options.map((option, index) => (
                <li key={option.id} className={styles.listItem}>
                    <SelectRangeItem
                        name={name}
                        value={option.value}
                        onChange={handleItemChange}
                        label={option.label}
                        isActive={isValueInRange(value, option.value, firstOption.value, lastOption.value)}
                        isNonActive={isValueInRange(value, option.value, firstOption.value, lastOption.value, -1)}
                        isDisabled={option.isDisabled}
                        isFirst={index === 0}
                        isLast={index === options.length - 1}
                        className={itemClassName}
                    />
                </li>
            ))}
        </ul>
    );
};
import React from "react";
import classNames from "classnames";

import {ISelectRangeProps} from "../types/ISelectRangeProps";
import {isValueInRange} from "../utils/is_value_in_range";
import {updateSingleValueBounds} from "../utils/update_single_value_bounds";
import {updateValueBounds} from "../utils/update_value_bounds";
import {SelectRangeItem} from "./SelectRangeItem";

import * as styles from "./SelectRange.module.css";

export const SelectRange = (props: ISelectRangeProps) => {
    const {className, itemClassName, name, onChange, options, value, variant = "range"} = props;

    const handleItemChange = (itemName: string, itemValue: number) => {
        if (options.length === 0) return;

        if (variant === "single") {
            onChange(itemName, updateSingleValueBounds(itemValue));
            return;
        }

        const firstOption = options[0];
        const lastOption = options[options.length - 1];
        const allOptionValues = options.map((option) => option.value);

        onChange(itemName, updateValueBounds(value, itemValue, firstOption.value, lastOption.value, allOptionValues));
    };

    if (options.length === 0) {
        return null;
    }

    const firstOption = options[0];
    const lastOption = options[options.length - 1];

    return (
        <ul className={classNames(styles.container, className)}>
            {options.map((option, index) => (
                <li key={option.id} className={styles.listItem}>
                    <SelectRangeItem
                        name={name}
                        value={option.value}
                        onChange={handleItemChange}
                        label={option.label}
                        isActive={isValueInRange(value, option.value, firstOption.value, lastOption.value)}
                        isNonActive={isValueInRange(value, option.value, firstOption.value, lastOption.value, -1)}
                        isDisabled={option.isDisabled}
                        isFirst={index === 0}
                        isLast={index === options.length - 1}
                        className={itemClassName}
                    />
                </li>
            ))}
        </ul>
    );
};
